import * as React from 'react';

function SkiJumping(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.001 10.238l.078-.051L12.13 7.8l3.2-1.572c.733-.361 1.477.467 1.023 1.139L9.54 17.409l1.556-.538 2.719-.954 2.151-.775.754-.282.539-.211.239-.102.082-.039c.908-.445 1.82-1.807 1.82-2.631a.78.78 0 01.235-.556.807.807 0 011.13 0 .78.78 0 01.235.556c0 1.438-1.27 3.332-2.704 4.037l-.092.043-.331.142-.71.276-1.511.557-2.346.835-2.456.857-6.376 2.191-.412.141a.813.813 0 01-.61-.035.791.791 0 01-.408-.45.774.774 0 01.036-.6.796.796 0 01.458-.4l3.493-1.197 6.322-9.32-.453.222L8.9 11.534a.811.811 0 01-1.07-.232.775.775 0 01.17-1.064zm9.072-6.662A2.002 2.002 0 0118.487 3a2.03 2.03 0 011.414.576 1.964 1.964 0 01.586 1.39 1.936 1.936 0 01-.586 1.389 2.017 2.017 0 01-1.414.576c-.53 0-1.039-.208-1.414-.576a1.948 1.948 0 01-.586-1.39c0-.521.211-1.02.586-1.39z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SkiJumping;
